import React from "react";
import styled from "styled-components";

type Props = {
  number: number;
};

export const StepNumber: React.VFC<Props> = ({ number }) => <StyledStepNumber>{number}</StyledStepNumber>;

export const StyledStepNumber = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eaf0f9;
`;
